import { useQuery } from '@tanstack/react-query'
import moment from 'moment'
import { getReportsErrorRate } from '@global/api'
import { IReportsErrorRateResponse } from '@global/api/types'

interface ISubmissionData {
  data: IReportsErrorRateResponse[]
  totalComplete: number
  totalErrors: number
}

export const DEFAULT_ERROR_REPORTS_QUERY_PARAMS = {
  numberOfDaysToFilter: '180',
  isFilteredByRow: 1,
}
const SIX_MONTHS_AGO = moment().subtract(5, 'months').startOf('month').valueOf()

export const useReportsErrorRateQuery = () =>
  useQuery({
    queryKey: [
      'roi-submissions-error-rate',
      DEFAULT_ERROR_REPORTS_QUERY_PARAMS.numberOfDaysToFilter,
      DEFAULT_ERROR_REPORTS_QUERY_PARAMS.isFilteredByRow,
    ],
    queryFn: ({ signal }) => getReportsErrorRate({ signal, ...DEFAULT_ERROR_REPORTS_QUERY_PARAMS }),
    refetchOnWindowFocus: false,
    select: (data: IReportsErrorRateResponse[]): ISubmissionData => {
      const transformedData = data
        ?.filter(item => {
          const itemDate = moment(item.date)
          return itemDate.valueOf() >= SIX_MONTHS_AGO
        })
        .map(item => ({
          ...item,
          errors: parseInt(item.error_count, 10),
          complete:
            (item?.total_rows || item?.total_submissions || 0) - parseInt(item.error_count, 10),
        }))

      const totalComplete = transformedData.reduce((acc, curr) => acc + curr.complete, 0)
      const totalErrors = transformedData.reduce((acc, curr) => acc + curr.errors, 0)

      return {
        data: transformedData,
        totalComplete,
        totalErrors,
      }
    },
  })
